























































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/agiles/common';

@Component
export default class PermissionView extends Vue {
  public items: Common.Permission[] = new Array();
  public params: Common.PermissionQuery = new Common.PermissionQuery();
  public importQuery = new Common.ImportQuery('アクセス権限', 'Permission');
  public exportQuery = new Common.ExportQuery('アクセス権限', this.params);
  public sortOptions: any = [
    { value: 'id', text: 'ID' },
    { value: 'userId', text: '割当先' },
    { value: 'name', text: '名称' },
  ];
  public permissionItems: string[];
  public created(){
    this.$api.formatter.ensureListLoaded('permissionCode').then(()=>{
      this.permissionItems = this.$api.formatter.getOptions('permissionCode').map(obj =>obj.value);
    });
  }
}
